import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
const bottles = [{
  name: "Aerial Flyovers",
  img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675093/img/trow_drone_flyover_view.png"
}, {
  name: "Clubhouse Media",
  img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675093/img/trow_clubhouse_cinematic.png"
}, {
  name: "Course Graphics",
  img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675093/img/trow_yardage_graphics.png"
}];
export default function LixrExperienceBegins() {
  return;
}